export const FULLSCREEN_DIALOG_CONFIG = {
  minWidth: '100vw',
  minHeight: '100vh',
  panelClass: 'fullscreen-dialog',
};
